import type { StatusChipVariant } from '@/components/ui/status-chip';
import { ABUSE_SUBJECT_TYPES, type AbuseSubjectKey, type AbuseSubjectType } from '@/services/api/abuse';
import type { AlertSeverity, AlertStatus, ComplianceAlert } from '@/services/api/compliance-alerts';

// Legacy parity: critical and high render identically
export const SEVERITY_CHIP_VARIANTS: Record<AlertSeverity, StatusChipVariant> = {
  critical: 'destructive',
  high: 'destructive',
  medium: 'warning',
  low: 'success',
};

export const STATUS_CHIP_VARIANTS: Record<AlertStatus, StatusChipVariant> = {
  active: 'info',
  dismissed: 'muted',
};

export const getDaysRemainingClass = (daysRemaining: number): string => {
  if (daysRemaining <= 1) return 'text-red-500';
  if (daysRemaining < 4) return 'text-amber-500';
  return 'text-emerald-500';
};

export type BannerVariant = 'destructive' | 'warning' | 'success' | 'info';

export const getBannerVariant = (severity: AlertSeverity | undefined, isOverdue: boolean): BannerVariant => {
  if (isOverdue) return 'destructive';
  if (severity === 'critical' || severity === 'high') return 'destructive';
  if (severity === 'medium') return 'warning';
  if (severity === 'low') return 'success';
  return 'info';
};

const isAbuseSubjectType = (value: unknown): value is AbuseSubjectType => ABUSE_SUBJECT_TYPES.includes(value as AbuseSubjectType);

export const getAbuseCaseSubject = (alert: ComplianceAlert): AbuseSubjectKey | null => {
  const { event_type: eventType, subject_type: subjectType, subject_id: subjectId } = alert;

  if (eventType !== 'abuse_score_threshold' || !isAbuseSubjectType(subjectType) || typeof subjectId !== 'string') return null;
  return { subjectType, subjectId };
};
